import LoginPage from "../../pages/LoginPage";
import styles from "./loginpopup.module.css";
const LoginPopup = () => {
  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <LoginPage removeContainer removeFooter popupView />
      </div>
    </div>
  );
};
export default LoginPopup;
